"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DependencyHuntingDistrictToEventInvitation = exports.HuntingDistrict = void 0;
const obejct_diff_1 = require("../utils/obejct-diff");
const network_constants_1 = require("./network.constants");
const extractCoords = (str) => {
    const split = str.split('|');
    const long = +split[0];
    const lat = +split[1];
    if (Number.isNaN(long) || Number.isNaN(lat))
        throw new Error(`${str} does not contain formattable numbers`);
    else
        return [lat, long];
};
class HuntingDistrict {
    static featureToFirebaseOutline(feature) {
        var _a, _b, _c, _d, _e, _f, _g;
        if ((_a = feature.geometry) === null || _a === void 0 ? void 0 : _a.coordinates[0]) {
            const coordinates = feature.geometry.coordinates[0];
            let listCoords = [];
            coordinates.forEach((element) => {
                listCoords.push(`${String(element[1])}|${String(element[0])}`);
            });
            let interior = [];
            if (((_b = feature.geometry) === null || _b === void 0 ? void 0 : _b.coordinates.length) > 1) {
                // interior polygons
                for (let i = 1; i <= ((_c = feature.geometry) === null || _c === void 0 ? void 0 : _c.coordinates.length) - 1; ++i) {
                    let coords = [];
                    if ((_e = (_d = feature.geometry) === null || _d === void 0 ? void 0 : _d.coordinates[i]) === null || _e === void 0 ? void 0 : _e.length) {
                        (_f = feature.geometry) === null || _f === void 0 ? void 0 : _f.coordinates[i].forEach((coord) => {
                            coords.push(`${String(coord[1])}|${String(coord[0])}`);
                        });
                    }
                    if (coords.length > 0)
                        interior.push({ coordinates: coords });
                }
            }
            const polygon = {};
            if (listCoords.length > 0)
                Object.assign(polygon, { coordinates: listCoords });
            if (interior.length > 0)
                Object.assign(polygon, { interior: interior });
            const outline = {
                identifier: (_g = feature.properties) === null || _g === void 0 ? void 0 : _g.outlineId,
                polygon
            };
            return outline;
        }
        else {
            return undefined;
        }
    }
    constructor(additionalContext) {
        this.className = "HuntingDistrict";
        this.context = undefined;
        this.identifier = undefined;
        this.contextId = undefined;
        this.contextIds = undefined;
        this.contextIdRights = undefined;
        this.county = undefined;
        this.country = undefined;
        this.countryCode = undefined;
        this.name = undefined;
        this.administrativeName = undefined;
        this.state = undefined;
        this.stateCode = undefined;
        this.huntingOffice = undefined;
        this.huntingOfficeId = undefined;
        this.veterinarianOffice = undefined;
        this.veterinarianOfficeId = undefined;
        this.oldIdentifier = undefined;
        this.gameOriginData = undefined;
        this.extra = undefined;
        this.updateTimestamp = undefined;
        this.hiTierActive = undefined;
        this.creationDate = undefined;
        this.huntingTenant = undefined;
        this.feeDebtor = undefined;
        this.templateId = undefined;
        this.createdByUserName = undefined;
        this.createdByUserId = undefined;
        this.nvTrichinellaActive = undefined;
        this.mandatorySampleTypes = undefined;
        this.veterinaryOffice = undefined;
        this.veterinaryOfficeId = undefined;
        this.outlines = undefined;
        this.context = additionalContext;
    }
    setFromAny(element) {
        const { identifier, contextId, contextIds, contextIdRights, county, country, countryCode, name, administrativeName, state, stateCode, huntingOffice, huntingOfficeId, veterinarianOffice, veterinarianOfficeId, gameOriginData, hiTierActive, updateTimestamp, creationDate, extra, huntingTenant, feeDebtor, templateId, createdByUserId, createdByUserName, nvTrichinellaActive, mandatorySampleTypes, veterinaryOffice, veterinaryOfficeId } = element;
        //...
        this.identifier = identifier ? identifier : this.identifier;
        this.contextId = contextId ? contextId : this.contextId;
        this.contextIds = contextIds ? contextIds : this.contextIds;
        this.contextIdRights = contextIdRights ? contextIdRights : this.contextIdRights;
        this.county = county ? county : this.county;
        this.country = country ? country : this.country;
        this.countryCode = countryCode ? countryCode : this.countryCode;
        this.name = name ? name : this.name;
        this.administrativeName = administrativeName ? administrativeName : this.administrativeName;
        this.state = state ? state : this.state;
        this.stateCode = stateCode ? stateCode : this.stateCode;
        this.huntingOffice = huntingOffice ? huntingOffice : this.huntingOffice;
        this.huntingOfficeId = huntingOfficeId ? huntingOfficeId : this.huntingOfficeId;
        this.veterinarianOffice = veterinarianOffice ? veterinarianOffice : this.veterinarianOffice;
        this.veterinarianOfficeId = veterinarianOfficeId ? veterinarianOfficeId : this.veterinarianOfficeId;
        this.gameOriginData = gameOriginData ? gameOriginData : this.gameOriginData;
        this.extra = extra ? extra : this.extra;
        this.hiTierActive = hiTierActive ? hiTierActive : this.hiTierActive;
        this.updateTimestamp = updateTimestamp ? (0, obejct_diff_1.isDate)(updateTimestamp) ? updateTimestamp : (0, obejct_diff_1.firestoreTimestampToDate)(updateTimestamp) : this.updateTimestamp;
        this.creationDate = creationDate ? (0, obejct_diff_1.isDate)(creationDate) ? creationDate : (0, obejct_diff_1.firestoreTimestampToDate)(creationDate) : this.creationDate;
        this.huntingTenant = huntingTenant ? huntingTenant : this.huntingTenant;
        this.feeDebtor = feeDebtor ? feeDebtor : this.feeDebtor;
        this.templateId = templateId ? templateId : this.templateId;
        this.createdByUserName = createdByUserName ? createdByUserName : this.createdByUserName;
        this.createdByUserId = createdByUserId ? createdByUserId : this.createdByUserId;
        this.nvTrichinellaActive = nvTrichinellaActive ? nvTrichinellaActive : this.nvTrichinellaActive;
        this.mandatorySampleTypes = mandatorySampleTypes ? mandatorySampleTypes : this.mandatorySampleTypes;
        this.veterinaryOffice = veterinaryOffice ? veterinaryOffice : this.veterinaryOffice;
        this.veterinaryOfficeId = veterinaryOfficeId ? veterinaryOfficeId : this.veterinaryOfficeId;
    }
    getListItemTitle() {
        return this.name;
    }
    searchFilter(filter) {
        const str = `${this.name}${this.administrativeName}${this.county}`.toLowerCase();
        return str.includes(filter);
    }
    getOutlineGeoJson() {
        if (!this.outlines)
            return undefined;
        let listFeature = this.getOutlinesAsFeatureList();
        const geoJsonBase = {
            'type': 'geojson',
            'data': {
                'type': 'FeatureCollection',
                'features': listFeature
            }
        };
        return geoJsonBase;
    }
    getOutlinesAsFeatureList() {
        var _a;
        let listFeature = [];
        (_a = this.outlines) === null || _a === void 0 ? void 0 : _a.forEach((outline, index) => {
            var _a;
            // parse outline coordinates.. 
            let list = [];
            outline.polygon.coordinates.forEach(coordinate => {
                try {
                    const coord = extractCoords(coordinate);
                    list.push(coord);
                }
                catch (error) {
                    console.warn(error);
                }
            });
            const listInterior = [];
            if (outline.polygon.interior) {
                (_a = outline.polygon.interior) === null || _a === void 0 ? void 0 : _a.forEach(element => {
                    var _a;
                    const coord = [];
                    (_a = element.coordinates) === null || _a === void 0 ? void 0 : _a.forEach((coordinate) => {
                        try {
                            const extracted = extractCoords(coordinate);
                            coord.push(extracted);
                        }
                        catch (error) {
                            console.warn(error);
                        }
                    });
                    if (coord.length > 0) {
                        listInterior.push(coord);
                    }
                });
            }
            let geometry = null;
            if (listInterior.length > 0) {
                geometry = {
                    type: 'Polygon',
                    coordinates: [
                        list,
                        ...listInterior
                    ]
                };
            }
            else {
                geometry = {
                    type: 'Polygon',
                    coordinates: [
                        list
                    ]
                };
            }
            let feature = {
                'id': `${outline.identifier}`,
                'type': 'Feature',
                'properties': {
                    'outlineId': outline.identifier
                },
                geometry
            };
            listFeature.push(feature);
        });
        return listFeature;
    }
    /**
     * Function for skipping objects and data while deepcopying class.
     * used as optional Input for deepCopy(any, replacerFn)
     * @param key
     */
    replacerFn(key) {
        if (key == "context" || key == "outlines" || key == "className")
            return false;
        else
            return true;
    }
}
exports.HuntingDistrict = HuntingDistrict;
HuntingDistrict.className = "HuntingDistrict";
exports.DependencyHuntingDistrictToEventInvitation = {
    collectionName: network_constants_1.NetworkConstants.COLLECTION_EVENT_INV,
    mapping: new Map([
        ["name", "huntingDistrictName"]
    ]),
    getQuery: (firestore, origin, now) => {
        return (now != null) ? firestore.collection(network_constants_1.NetworkConstants.COLLECTION_EVENT_INV)
            .where('huntingDistrictId', '==', origin['identifier'])
            .where('eventDate', '>=', now)
            :
                firestore.collection(network_constants_1.NetworkConstants.COLLECTION_EVENT_INV)
                    .where('huntingDistrictId', '==', origin['identifier']);
    },
    getDoc: (firestore, identifier) => {
        return null;
    }
};
